
import { useRoutes } from 'react-router-dom';
import routes from './router/config';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';
import ScrollToTop from './components/feature/ScrollToTop';
import { BrowserRouter } from 'react-router-dom';

function App() {
  const routeElement = useRoutes(routes);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {routeElement}
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

function AppWrapper() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <App />
    </BrowserRouter>
  );
}

export default AppWrapper;
